import { render, staticRenderFns } from "./ThreeCardYellowLayout.vue?vue&type=template&id=bf3d97c6&scoped=true"
var script = {}
import style0 from "./ThreeCardYellowLayout.vue?vue&type=style&index=0&id=bf3d97c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3d97c6",
  null
  
)

export default component.exports